import {
  CARD_LIST_ATTEMPT,
  CARD_LIST_SUCCESS,
  CARD_LIST_FAILED
} from "../types/cardsTypes";

const INITIAL_STATE = {
  loading: false,
  list: [],
  error: ""
};

function cards(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CARD_LIST_ATTEMPT:
      return {
        ...state,
        loading: true
      };

    case CARD_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data.list,
        error: ""
      };

    case CARD_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        list: []
      };
    default:
      return state;
  }
}
export default cards;
